import * as Sentry from "@sentry/react";

import type { LaborAmendCompletionProvenanceFailureReason } from "@/encounters/constants/labor-amend-completion-provenance-failure-reason";

export interface ReportLaborEncounterAmendProvenanceFailureParams {
  reason: LaborAmendCompletionProvenanceFailureReason;
  details?: string;
  encounterId: string;
  encounterQuestionnaireResponseId?: string;
  encounterQuestionnaireResponseVersionId?: string;
}

/**
 * Reports a non-blocking labor amend Provenance write failure to Sentry.
 */
export function reportLaborEncounterAmendProvenanceFailure({
  reason,
  details,
  encounterId,
  encounterQuestionnaireResponseId,
  encounterQuestionnaireResponseVersionId,
}: ReportLaborEncounterAmendProvenanceFailureParams): void {
  Sentry.captureMessage("Labor amend completed but Provenance was not recorded", {
    level: "warning",
    extra: {
      reason,
      details,
      encounterId,
      encounterQuestionnaireResponseId,
      encounterQuestionnaireResponseVersionId,
    },
  });
}
